import React from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import ThingsToKnow from './ThingsToKnow'
import PaymentInformation from './PaymentInformation'
import { FIXED, NOT_FIXED, SERVICE_FIBRE, SERVICE_NBN } from '../constants'
import BroadbandPlanForm from '../forms/BroadbandPlanForm'
import globals from '../globals'

class ChangePlanBroadband extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            plans: [],
            provider: ''
        }
    }

    componentDidMount () {
        this.getPlans()
    }

    componentDidUpdate (prevProps) {
        if (prevProps.serviceDetails !== this.props.serviceDetails) {
            this.getPlans()
        }
    }

    getPlans () {
        if (this.state.plans.length === 0) {
            DataSource.getData(`/api/getBroadbandPlans/${this.props.serviceId}`, result => {
                this.setState({
                    plans: result.plans,
                    provider: result.provider,
                    isLoaded: true
                })
            }, () => {
                this.setState({ hasError: true, isLoaded: true })
            })
        }
    }

    handleSuccess (response) {
	    this.props.updateServiceDetails()

	    let speed = ''
	    if (response.data && response.data.new_plan && response.data.new_plan.data) {
	        speed = `${this.props.type}${response.data.new_plan.data.speed}`
        }

        globals.pushEvent('BroadbandPlanChangeSubmit', { speed: speed })
    }

    render () {
        return (
            <div>
                <div className='change-plan-nbn module'>
                    <Heading title='Change my plan'>
                        <div className='col-md-7 col-12 mt-md-0 mt-2 d-flex align-items-center justify-content-md-end'>
                            {this.props.serviceDetails.flipReady && this.props.serviceDetails.flipDate
                                ? `Your service will be Fibre Upgrade ready from ${this.props.serviceDetails.flipDate}`
                                : 'Note: your existing contract period will apply'}
                        </div>
                    </Heading>
                    <ModuleWithLoader isLoaded={this.state.isLoaded} hasError={this.state.hasError}>
                        <div className='p-4'>
                            <BroadbandPlanForm
                                type={this.props.type}
                                serviceId={this.props.serviceId}
                                plans={this.state.plans}
                                provider={this.state.provider}
                                serviceDetails={this.props.serviceDetails}
                                handleSuccess={this.handleSuccess.bind(this)}
                                isNotSubscribedAndNotInFreeTrial={this.props.isNotSubscribedAndNotInFreeTrial}
                            />
                        </div>
                    </ModuleWithLoader>
                </div>
                <PaymentInformation />
                <div id='terms'>
                    <ThingsToKnow type={this.props.serviceDetails.flipReady ? 'changePlanFlipToFibre' : (this.props.type === SERVICE_NBN ? 'changePlanNbn' : 'changePlanFibre')} />
                </div>
            </div>
        )
    }
}

ChangePlanBroadband.propTypes = {
    type: PropTypes.oneOf([SERVICE_NBN, SERVICE_FIBRE]).isRequired,
    serviceId: PropTypes.string.isRequired,
    serviceDetails: PropTypes.shape({
        contract: PropTypes.oneOf([FIXED, NOT_FIXED]),
        monthsRemaining: PropTypes.number,
        serviceNo: PropTypes.string,
        contractStatus: PropTypes.string,
        contractEndDate: PropTypes.string,
        monthlyFee: PropTypes.string,
        flipDate: PropTypes.string,
        flipReady: PropTypes.bool
    }).isRequired,
    isNotSubscribedAndNotInFreeTrial: PropTypes.bool,
    updateServiceDetails: PropTypes.func.isRequired
}

export default ChangePlanBroadband



// WEBPACK FOOTER //
// ./resources/js/modules/ChangePlanBroadband.js